import { Button, styled } from "@mui/material";
import { useRef } from "react";
import { OnDragEndResponder } from "react-beautiful-dnd";
import colors from "../../../theme/themeConstants";
import CropFile from "../CropFile";
import UploadMoveBack from "../UploadMoveBack";
import UploadMultiple from "../UploadMultiple";
import VideoTrimmer from "../VideoTrimmer";

interface IProps {
  next: () => void;
  back: () => void;
  fileUrl: string;
  fileType: string | null;
  file: any;
  files: any;
  setFiles: (files: any) => void;
  setFileUrl: (url: string) => void;
  duration: number[];
  setDuration: (duration: number[]) => void;
  timeLineURL: string;
  uploadError: string | null;
  removeFileFromArray: (index: number) => void;
  isFetching: boolean;
  onDragEnd: OnDragEndResponder;
  fromUrl: any;
}

const UploadFirstStep = (props: IProps) => {
  const {
    next,
    back,
    fileUrl,
    setFileUrl,
    setFiles,
    file,
    files,
    fileType,
    duration,
    setDuration,
    timeLineURL,
    uploadError,
    removeFileFromArray,
    isFetching,
    onDragEnd,
    fromUrl
  } = props;

  const playerRef = useRef<any>();

  const getTitle = (): string => {
    if (fileType === "image") {
      return "Image Preview";
    } else if (fileType === "video") {
      return "Video Cutter";
    } else {
      return "Multiple Upload";
    }
  };

  return (
    <UploadContainer
      sx={{
        "@media screen and (max-width: 767px)": {
          paddingBottom: "1rem"
        }
      }}
    >
      <UploadMoveBack
        back={back}
        text={getTitle()}
        files={files}
        setFiles={setFiles}
      />
      {fileType === "multiple" ? (
        <UploadMultiple
          files={files}
          removeFileFromArray={removeFileFromArray}
          onDragEnd={onDragEnd}
        />
      ) : (
        <CropContainer>
          <CropFile
            fileType={fileType}
            fileUrl={fileUrl}
            setFileUrl={setFileUrl}
            file={file}
            playerRef={playerRef}
            duration={duration}
            fromUrl={fromUrl}
          />
          {fileType === "video" && (
            <VideoTrimmer
              video={file}
              newDuration={duration}
              setNewDuration={setDuration}
              timeLineURL={timeLineURL}
              playerRef={playerRef}
              fromUrl={fromUrl}
            />
          )}
        </CropContainer>
      )}
      <Button variant="contained" fullWidth sx={{
        background: colors.purpleGradient,
        minHeight: "3rem",
        fontSize: "16px",
        fontWeight: "500",
        borderRadius: "38px",
        fontFamily: "Poppins",
        marginTop: "24px",
      }} onClick={next} disabled={uploadError !== null || isFetching}>
        Next
      </Button>
    </UploadContainer>
  );
};

export default UploadFirstStep;

export const UploadContainer = styled("div")({
  paddingTop: "32px",
  paddingBottom: "2rem",
  position: "relative",
  "@media screen and (max-width: 767px)": {
    paddingBottom: "4.5rem"
  }
});

const CropContainer = styled("div")({
  marginTop: "1rem",
});
